import {
  EDITOR_UPDATE_SNIPPET_BEGIN,
  EDITOR_UPDATE_SNIPPET_SUCCESS,
  EDITOR_UPDATE_SNIPPET_FAILURE,
  EDITOR_UPDATE_SNIPPET_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../home/app_util';

export function updateSnippet(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EDITOR_UPDATE_SNIPPET_BEGIN,
    });
    const { projectId, version, templateId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/snippet-templates/${templateId}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EDITOR_UPDATE_SNIPPET_SUCCESS,
              data: res.data,
              templateId: templateId,
            });
            Mixpanel.track('Updated Snippet on builder', { uuid: templateId });
            toast.success('Snippet Updated Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EDITOR_UPDATE_SNIPPET_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to update snippet on builder');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EDITOR_UPDATE_SNIPPET_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to update snippet on builder');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateSnippetError() {
  return {
    type: EDITOR_UPDATE_SNIPPET_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_UPDATE_SNIPPET_BEGIN:
      return {
        ...state,
        updateSnippetPending: true,
        updateSnippetError: null,
      };

    case EDITOR_UPDATE_SNIPPET_SUCCESS:
      let snippets = state.snippets;
      let index = snippets.findIndex((snip) => {
        return snip.uuid == action.templateId;
      });
      snippets[index] = action.data;
      return {
        ...state,
        updateSnippetPending: false,
        updateSnippetError: null,
        snippets: snippets,
        selectedSnippet: action.data,
      };

    case EDITOR_UPDATE_SNIPPET_FAILURE:
      return {
        ...state,
        updateSnippetPending: false,
        updateSnippetError: action.data.error,
      };

    case EDITOR_UPDATE_SNIPPET_DISMISS_ERROR:
      return {
        ...state,
        updateSnippetError: null,
      };

    default:
      return state;
  }
}
